import clsx from 'clsx'
import { motion } from 'framer-motion'
import { Fragment, useId } from 'react'

export default function SegmentSlider({
  title,
  description,
  value,
  onChange,
  minLabel,
  maxLabel,
}: {
  title: string
  description: string
  value: number
  onChange: (value: number) => void
  minLabel: string
  maxLabel: string
}) {
  const steps = [1, 2, 3, 4, 5]
  const indicatorId = useId()

  return (
    <div className="flex flex-col gap-3 md:flex-row md:items-center md:gap-6">
      <div className="text-gray-800 md:w-1/2">
        <p className="font-bold">{title}</p>
        <p className="text-sm">{description}</p>
      </div>
      <div className="md:w-1/2">
        <div
          role="radiogroup"
          aria-label={title}
          className="flex items-center rounded-xl bg-gray-200 p-1"
        >
          {steps.map((step, index) => (
            <Fragment key={step}>
              <button
                type="button"
                role="radio"
                aria-checked={value === step}
                onClick={() => onChange(step)}
                className="relative flex-1 rounded-lg py-2 text-center text-sm font-bold"
              >
                {value === step && (
                  <motion.span
                    layoutId={indicatorId}
                    className="absolute inset-0 rounded-lg bg-blue-700 shadow-sm"
                    transition={{ type: 'spring', bounce: 0.2, duration: 0.35 }}
                  />
                )}
                <span
                  className={clsx(
                    'relative z-10 transition-colors',
                    value === step ? 'text-white' : 'text-gray-900'
                  )}
                >
                  {step}
                </span>
              </button>
              {index < steps.length - 1 && (
                <span
                  className={clsx(
                    'h-5 w-px shrink-0 bg-gray-300',
                    (value === step || value === step + 1) && 'invisible'
                  )}
                />
              )}
            </Fragment>
          ))}
        </div>
        <div className="mt-1 flex justify-between text-2xs text-gray-600">
          <span>{minLabel}</span>
          <span>{maxLabel}</span>
        </div>
      </div>
    </div>
  )
}
